const getAuthURL = () => {
  if (process.env.REACT_APP_AUTH_URL) return process.env.REACT_APP_AUTH_URL;
  return `https://member${
    process.env.REACT_APP_BUILD_TARGET === 'production' ? '' : '-staging'
  }.lifetales.com/`;
};
const authURL = getAuthURL();
export default authURL;
